export enum InputSize {
   Normal = "normal",
   Large = "large"
}

export enum InputState {
   Normal = "normal",
   Error = "error"
}

export enum InputVariant {
   Border = "border",
   Background = "background"
}
